import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function CustomFormValidators(): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    if (c.get('password')?.value !== c.get('confirmPassword')?.value) {
      return { passwordsMismatch: true };
    }
    return null;
  }
}
